import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import Popup from "reactjs-popup";

function ProgramModal({ concert, clear }) {
	const navigateHook = useNavigate();

	const month = concert?.date?.toLocaleDateString("fr-CA", {
		month: "long",
	});

	if (!concert) return null;

	return (
		<Popup
			modal
			open
			onClose={clear}
			contentStyle={{
				width: window.innerWidth > 768 ? "50%" : "90%",
				height: window.innerHeight > 768 ? "75%" : "85%",
				borderRadius: "10px",
				paddingLeft: "20px",
				paddingRight: "20px",
			}}
			closeOnDocumentClick={window.innerWidth > 768 ? true : false}
		>
			{(close) => (
				<>
					<button
						className="absolute -right-3 -top-3 bg-white rounded-full w-8 h-8 flex justify-center items-center text-red-500 font-bold text-2xl border-2 border-black outline-none"
						onClick={close}
					>
						<span className="mb-[2px] ml-[1px]">&times;</span>
					</button>

					<div className="overflow-y-auto h-full">
						<div className="mb-4 pt-4">
							<h1 className="text-center font-bold text-2xl">
								Programme - {concert.date.getDate()}{" "}
								{month.charAt(0).toUpperCase() + month.slice(1)}
							</h1>
							<h2 className="text-center font-semibold text-xl">
								{concert.artist}
							</h2>
							<h3 className="text-center font-semibold text-xl">
								{concert.secondaryArtist}
							</h3>
						</div>

						{concert.program.map((piece, index) => (
							<div
								className={classNames(
									"grid grid-cols-10 border-b-2 py-2",
									{
										"border-t-2": index === 0,
									}
								)}
								key={index}
							>
								<div className="col-span-6">
									<span className="font-semibold">
										{piece.title}
									</span>
									{piece.items && (
										<ul className="list-disc list-inside -space-y-1">
											{piece.items.map((item, index) => (
												<li key={index}>{item}</li>
											))}
										</ul>
									)}
								</div>
								<div className="col-span-4 text-right">
									{piece.author}
								</div>
							</div>
						))}

						<div className="p-3">
							<div className="flex justify-between mb-2">
								<button
									className="bg-orange-500 text-white font-bold py-2 rounded-full w-[48%]"
									onClick={() => {
										close();
										navigateHook("/partenaires");
									}}
								>
									Nos partenaires
								</button>

								<button className="bg-blue-500 text-white font-bold py-2 rounded-full w-[48%]">
									<a
										href="https://www.facebook.com/festivalorguedesaintemarie"
										target="_blank"
										rel="noreferrer"
									>
										Notre Facebook
									</a>
								</button>
							</div>
							<button
								className="bg-red-500 text-white font-bold py-2 rounded-full w-full"
								onClick={() =>
									window.open("/programme2025.pdf", "_blank")
								}
							>
								Programme complet
							</button>
						</div>
					</div>
				</>
			)}
		</Popup>
	);
}

export default ProgramModal;
